const BASE_URL = "https://crm.blueberrymerchant.com/server";
// const BASE_URL = "http://localhost:3000/";

export default BASE_URL;